import { Iterable as ImmutableIterable, List as ImmutableList } from 'immutable';
export const checkIsKeyedIterable = options => ImmutableIterable.isIterable(options) && ImmutableIterable.isKeyed(options);
export const checkIsList = list => ImmutableList.isList(list);
export const ensureIsList = values => {
  if (checkIsList(values)) {
    return values;
  }
  return ImmutableList(values);
};
export const convertListToArray = list => checkIsList(list) ? list.toArray() : list;